import React from 'react'

const Footer = (props) => {
    return (
        <footer>
            <h6>site created by <a href="https://www.davidvdev.com">David Vogel</a></h6>
        </footer>
    )
}

export default Footer